<template>
  <div class="container-fluid">
    <card>
      <h4 class="card-title">{{ $t('Subscriptions') }}</h4>
      <subscriptions-list
        :data='subscriptions'
        :loading="loadingSubscriptions"
        @changeFilter="changeFilter"
        @sort="sortSubscriptions"
        v-on:subscriptionDeleted="fetchSubscriptions"
      />
    </card>
  </div>
</template>

<script>
import axios from 'axios'
import SubscriptionsList from '@/components/SubscriptionsList'

export default {
  components: {
    SubscriptionsList
  },
  data() {
    return {
      subscriptions: [],
      loadingSubscriptions: false
    }
  },
  methods: {
    fetchSubscriptions (agrmid, filterActive = true, sort = null) {
      this.loadingSubscriptions = true
      axios.get('subscriptions', {
        params: {
          agrmid: agrmid,
          filterActive: filterActive,
          sortColumn: sort ? sort.column : null,
          sortOrder: sort ? sort.order : null
        }
      }).then(promise => {
        this.subscriptions = promise.data.results
        this.loadingSubscriptions = false
      }).catch(error => {
        console.log(error)
        this.loadingSubscriptions = false
      })
    },
    sortSubscriptions(params) {
      const { column, order, filterActive } = params
      if (!column || !order) {
        this.fetchSubscriptions(this.selectedAgrmId, filterActive)
      } else {
        this.fetchSubscriptions(this.selectedAgrmId, filterActive, { column: column, order: order })
      }
    },
    changeFilter(filterActive) {
      this.fetchSubscriptions(null, filterActive)
    }
  },
  mounted() {
    this.fetchSubscriptions()
  }
}
</script>

<style scoped>
  .moveInUp-enter-active {
    opacity: 0;
    transition: opacity 1s ease-in;
  }
</style>
